import React from 'react';
import PropTypes from 'prop-types';
import { StyledTimeInputField } from './TimeInput.style';

/**
 * The TimeInput component represents the standard html element `<input />` with adjusted styling.
 */

const TimeInput = React.forwardRef(
  (
    {
      className = '',
      invalid = false,
      onChange = () => {},
      readOnly = false,
      onBlur = () => {},
      ...inputAttributes
    },
    ref
  ) => {
    const browserIsFirefox =
      navigator.userAgent.includes(
        'Firefox'
      ); /* Time formatting is extra wide in Firefox browsers, requires more width for time input field to avoid cutoff */
    return (
      <StyledTimeInputField
        {...inputAttributes}
        onChange={onChange}
        onBlur={onBlur}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            event.preventDefault();
            ref.current?.blur();
          }
        }}
        ref={ref}
        type="time"
        $invalid={invalid}
        $readOnly={readOnly}
        disabled={readOnly}
        className={className}
        $extraWide={browserIsFirefox}
        data-test-invalid={invalid}
      />
    );
  }
);

TimeInput.propTypes = {
  /** ClassName is supported such that styled components can pass extra styling.
   * Do not use this to adjust the styling, because the ordering of the applied tailwind classes is undeterministic */
  className: PropTypes.string,
  /** Set the input to invalid state */
  invalid: PropTypes.bool,
  readOnly: PropTypes.bool,
  /** onChange event for input field */
  onChange: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  onBlur: PropTypes.func
};

export default TimeInput;
